class FooterAccordion extends HTMLElement {
  constructor() {
    super();
    this.accordionToggles = [];
    this.isInitialized = false;
    this.resizeTimeout = null;
  }

  connectedCallback() {
    if (!this.isInitialized) {
      this.init();
      this.isInitialized = true;
    }
  }

  init() {
    // Wait for DOM to be fully loaded
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setupAccordions());
    } else {
      this.setupAccordions();
    }
  }

  setupAccordions() {
    this.accordionToggles = document.querySelectorAll('.footer-accordion__toggle');
    
    this.accordionToggles.forEach(toggle => {
      toggle.addEventListener('click', (e) => this.handleToggleClick(e));
    });

    // Handle window resize with debounce
    window.addEventListener('resize', () => this.debouncedResize());
  }

  handleToggleClick(event) {
    const toggle = event.currentTarget;
    const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
    let content = toggle.nextElementSibling;
    
    // Skip the desktop title if it exists
    if (content && content.classList.contains('footer-accordion__desktop-title')) {
      content = content.nextElementSibling;
    }
    
    // Toggle current accordion
    toggle.setAttribute('aria-expanded', !isExpanded);
    
    if (!isExpanded) {
      content.style.maxHeight = content.scrollHeight + 'px';
    } else {
      content.style.maxHeight = '0';
    }
  }

  debouncedResize() {
    clearTimeout(this.resizeTimeout);
    this.resizeTimeout = setTimeout(() => {
      this.handleResize();
    }, 150);
  }

  handleResize() {
    // Close all accordions and reset state when resizing
    this.accordionToggles.forEach(toggle => {
      toggle.setAttribute('aria-expanded', 'false');
      const content = this.getAccordionContent(toggle);
      if (content) {
        if (window.innerWidth >= 768) {
          // Desktop: remove inline styles to let CSS take over
          content.style.maxHeight = 'none';
        } else {
          // Mobile: ensure accordions are closed
          content.style.maxHeight = '0';
        }
      }
    });
  }

  getAccordionContent(toggle) {
    let content = toggle.nextElementSibling;
    
    // Skip the desktop title if it exists
    if (content && content.classList.contains('footer-accordion__desktop-title')) {
      content = content.nextElementSibling;
    }
    
    return content;
  }

  // Method to programmatically open/close accordions
  toggleAccordion(accordionId, forceState = null) {
    const toggle = document.querySelector(`[aria-controls="${accordionId}"]`);
    if (!toggle) return;

    const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
    const shouldExpand = forceState !== null ? forceState : !isExpanded;
    
    const content = this.getAccordionContent(toggle);
    
    toggle.setAttribute('aria-expanded', shouldExpand);
    
    if (shouldExpand) {
      content.style.maxHeight = content.scrollHeight + 'px';
    } else {
      content.style.maxHeight = '0';
    }
  }

  // Method to close all accordions
  closeAllAccordions() {
    this.accordionToggles.forEach(toggle => {
      toggle.setAttribute('aria-expanded', 'false');
      const content = this.getAccordionContent(toggle);
      if (content) {
        content.style.maxHeight = '0';
      }
    });
  }

  // Method to open all accordions
  openAllAccordions() {
    this.accordionToggles.forEach(toggle => {
      toggle.setAttribute('aria-expanded', 'true');
      const content = this.getAccordionContent(toggle);
      if (content) {
        content.style.maxHeight = content.scrollHeight + 'px';
      }
    });
  }
}

// Register the custom element
customElements.define('footer-accordion', FooterAccordion);

// Export for potential module usage
if (typeof module !== 'undefined' && module.exports) {
  module.exports = FooterAccordion;
}
